export enum ThemeMode {
  DARK = 'dark',
  LIGHT = 'light'
}
